import config from '@common/config.js'
import FilePreviewerSupportedMIMETypes from '@/constants/file/FilePreviewerSupportedMIMETypes'

export default {
  data: () => {
    return {
      files: [],
      showUploadSuccess: false,
      allowedExtensions: ['gif', 'jpg', 'jpeg', 'png', 'pdf'],
      acceptedMimeTypes: [
        'image/png',
        'image/gif',
        'image/jpeg',
        'application/pdf',
      ],
    }
  },

  computed: {
    maxFileSize() {
      return config.get('app.file.upload.maxFileSizeInBytes')
    },
    generalFileUploadLimit() {
      return config.get('app.file.upload.generalFile.limit')
    },
    qualificationUploadLimit() {
      return config.get('app.file.upload.qualification.limit')
    },
    certificationUploadLimit() {
      return config.get('app.file.upload.certification.limit')
    },
    workExpUploadLimit() {
      return config.get('app.file.upload.workExp.limit')
    },
    hasExceededQualificationUploadLimit() {
      return this.files?.length > this.qualificationUploadLimit
    },
    hasExceededWorkExpUploadLimit() {
      return this.files?.length > this.workExpUploadLimit
    },
    hasExceededCertificationUploadLimit() {
      return this.files?.length > this.certificationUploadLimit
    },
    hasExceededGeneralFileUploadLimit() {
      return this.files?.length > this.generalFileUploadLimit
    },
  },

  methods: {
    clearFilesList: function () {
      this.files = []
    },
    removeFile(objectId) {
      const index = this.files.findIndex((file) => file.id === objectId)
      this.files.splice(index, 1)
    },
    isNotSupported: function (type) {
      return !FilePreviewerSupportedMIMETypes.includes(type)
    },
  },
}
